import { connect } from 'react-redux';
import NoteDialog from './note-dialog';

import { createNote, loadNotes, deleteNote, setDialogOpen } from '../../reducers/note.reducers';

const mapStateToProps = state => ({
  selectedReport: state.reports.selectedReport,
  selectedLocation: state.reports.selectedLocation,
  dateRange: state.filter.dateRange,
  notes: state.note.notes,
  open: state.note.dialogOpen,
});

const mapDispatchToProps = dispatch => ({
  createNote: note => dispatch(createNote(note)),
  loadNotes: filter => dispatch(loadNotes(filter)),
  deleteNote: note => dispatch(deleteNote(note)),
  setDialogOpen: open => dispatch(setDialogOpen(open)),
});

export default connect(mapStateToProps, mapDispatchToProps)(NoteDialog);
